
define('text!views/shared/form/input/state_component.html',[],function () { return '<label><%- this.field.label %></label>\r\n<select <%- (muted) ? \'disabled\' : \'\' %>>\r\n    <option value=\'-1\'><%- this.field.placeholder %></option>\r\n</select>\r\n<div class="form-input-feedback js-form-input-feedback"></div>';});

